import { render, staticRenderFns } from "./_ChangeStatus.vue?vue&type=template&id=66898ce6"
import script from "./_ChangeStatus.vue?vue&type=script&lang=js"
export * from "./_ChangeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports